<template>
    <b-modal
        v-model="modal"
        :id="'edit-module-motivation-modal'"
        :title="$t('modules.view_motivation')"
        :ok-title="$t('common.save')"
        @ok="save"
        :cancel-title="$t('common.cancel')"
        cancel-variant="outline-primary"
        size="lg"
        modal-class="apprentice-default-modal">
        <div>
            <b-form-textarea
                class="apprentice-textarea"
                id="module-motivation-textarea"
                v-model="motivation"
                :placeholder="$t('modules.fill_in_your_motivation_here_if_necessary')"
                rows="5">
            </b-form-textarea>
        </div>
    </b-modal>
</template>

<script>
export default {
    name: 'design-2021-module-show-motivation-edit-modal-component',
    data() {
        return {
            motivation: '',
            date: null,
            modal: false,
            module: null,
        };
    },
    methods: {
        save() {
            let data = {
                motivation: this.motivation,
            };

            this.alert.saving();

            this.axios.post(this.routes.moduleUserUpdate(this.module.id), data).then(
                (response) => {
                    this.module.update({ motivation: this.motivation });
                    this.alert.success();
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },

        show(module, date) {
            this.module = module;
            this.date = date;
            this.motivation = module.motivation;
            this.modal = true;
        },
    },
};
</script>

<style scoped></style>
